// extracted by mini-css-extract-plugin
export default {"treatment":"_treatment_tTX7a-","treatment-items":"_treatment-items_LLr1qz","suggestions-dropdown":"_suggestions-dropdown_tCeuGu"};